var _defs, _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg10281IconServiceAzureMigrate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a2071c0a-6e62-4699-8e32-285f1bc1e420",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a89be84a-3752-4123-adee-32901ecefd3d",
    x1: 10.75,
    y1: 13.54,
    x2: 10.75,
    y2: 2.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0078d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1380da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3c91e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#559cec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ea0ef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a2f994c2-8580-44cf-92d2-32655328fefe",
    x1: 7.45,
    y1: 17.24,
    x2: 7.45,
    y2: 1.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#198ab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#198ab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22a5cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#29bade"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#2ec9eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#31d1f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#32d4f5"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-migrate-281") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18,10.53A3.26,3.26,0,0,0,15.17,7.4a4.11,4.11,0,0,0-4.23-3.93,4.22,4.22,0,0,0-4,2.75A3.89,3.89,0,0,0,3.5,10a4,4,0,0,0,4.08,3.79h7l.18,0A3.29,3.29,0,0,0,18,10.53Z",
    fill: "url(#a89be84a-3752-4123-adee-32901ecefd3d)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9,11.22A3.35,3.35,0,0,0,12,8,4.21,4.21,0,0,0,7.65,4,4.33,4.33,0,0,0,3.51,6.79,4,4,0,0,0,0,10.63a4.06,4.06,0,0,0,4.2,3.9l.37,0h6.79l.18,0A3.38,3.38,0,0,0,14.9,11.22Z",
    fill: "url(#a2f994c2-8580-44cf-92d2-32655328fefe)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b1b7ddb8-8ec2-480f-967f-c2bf89d2fe16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.82,9.37h.85a.23.23,0,0,1,.17.07l2,2a.24.24,0,0,1,0,.35L5.12,14.46a.24.24,0,0,1-.17.07H4.14A.25.25,0,0,1,4,14.11l2.31-2.34a.23.23,0,0,0,0-.34L4.65,9.78A.24.24,0,0,1,4.82,9.37ZM8.25,6h.87a.25.25,0,0,1,.17.08l1.53,1.55a.24.24,0,0,1,0,.34l-2,1.91a.24.24,0,0,1-.17.07H7.92a.25.25,0,0,1-.18-.41L9.27,8a.25.25,0,0,0,0-.34L8.08,6.46A.24.24,0,0,1,8.25,6Zm1.79,4h.85a.28.28,0,0,1,.17.07l1.25,1.25a.25.25,0,0,1,0,.34L10.5,13.49a.23.23,0,0,1-.17.07H9.51a.24.24,0,0,1-.17-.41l1.42-1.44a.25.25,0,0,0,0-.34l-.89-.91A.24.24,0,0,1,10,10.05Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10281IconServiceAzureMigrate);
export default __webpack_public_path__ + "static/media/10281-icon-service-Azure-Migrate.344b390367a9b109d94360455efa93e6.svg";
export { ForwardRef as ReactComponent };